import React from 'react';

import {observer} from 'mobx-react';

import {useStores} from '../../../Hooks';
import ConditionalComponent from '../../Shared/ConditionalComponent';
import ConnectedFlowsTable from './ConnectedFlowsTable';
import RoleAccessRulesSection from './RoleAccessRulesSection';

const ProjectAdvancedTab = observer(({settings, threeDModels, roleAccess, connectedFlows}) => {
    const {generalStore} = useStores();
    const isRoleVisibilityEnabled = !!generalStore.domainSettings?.IsRoleVisibilityEnabled;

    return (
        <div>
            <ConditionalComponent if={threeDModels.length > 0}>
                <div className="settings-section">
                    <ConnectedFlowsTable threeDModels={threeDModels} isMirrored={settings.isMirrored} connectedFlows={connectedFlows} />
                </div>
            </ConditionalComponent>

            <ConditionalComponent if={isRoleVisibilityEnabled}>
                <div className="settings-section">
                    <RoleAccessRulesSection
                        roleAccess={roleAccess}
                        isRolesPermittedByDefault={settings.editedIsRolesPermittedByDefault}
                        onChangeDefault={settings.setEditedIsRolesPermittedByDefault}
                    />
                </div>
            </ConditionalComponent>
        </div>
    );
});

export default ProjectAdvancedTab;
